import OktaAuth from "@okta/okta-auth-js";
import {trackEvent} from "./google-analytics.helper";

const { hostname, host } = window.location;
const protocol = hostname === 'localhost' ? 'http' : 'https';
const redirectUrl = `${protocol}://${host}`;

const OKTA_INFO = {
  'localhost': {
    url: 'https://ciam-dev.primetherapeutics.com',
    clientId: '0oaczxb0zyQiDlega1d7',
  },
  'medi-calrx.dhcs.ca.magellansmartrxdev.com': {
    url: 'https://magellanhealthsso.oktapreview.com',
    clientId: '0oap2rm8e9vx1qHVH0h7'
  },
  'california.smartrx-dev.lh.primetherapeutics.com': {
    url: 'https://ciam-dev.primetherapeutics.com',
    clientId: '0oaczxb0zyQiDlega1d7'
  },
  'ca-dev.primetherapeutics.com': {
    url: 'https://ciam-dev.primetherapeutics.com',
    clientId: '0oaczxb0zyQiDlega1d7'
  },
  'california.smartrx-test.lh.primetherapeutics.com': {
    url: 'https://ciam-dev.primetherapeutics.com',
    clientId: '0oaczxb0zyQiDlega1d7'
  },
  'californiaqa.magellanrx.com': {
    url: 'https://ciam-dev.primetherapeutics.com',
    clientId: '0oaczxb0zyQiDlega1d7'
  },
  'ca-test.primetherapeutics.com': {
    url: 'https://ciam-dev.primetherapeutics.com',
    clientId: '0oaczxb0zyQiDlega1d7'
  },
  'california.smartrx-prod.lh.primetherapeutics.com': {
    url: 'https://ciam.primetherapeutics.com',
    clientId: '0oa4v6jutqtYuoPGz4h7'
  },
  'ca.primetherapeutics.com': {
    url: 'https://ciam.primetherapeutics.com',
    clientId: '0oa4v6jutqtYuoPGz4h7'
  },
  'medi-calrx.dhcs.ca.gov':{
    url: 'https://ciam.primetherapeutics.com',
    clientId: '0oa4v6jutqtYuoPGz4h7'
  }
};

const REDIRECT_URL = {
  'localhost': {
    login: `https://ciam-dev.primetherapeutics.com/app/UserHome`,
    logout: `${protocol}://${host}`,
    home: '/',
    contact: '/'
  },
  'medi-calrx.dhcs.ca.magellansmartrxdev.com': {
    login: `${protocol}://${host}/provider/login`,
    logout: `${protocol}://${host}`,
    home: '/',
    contact: '/'
  },  
  'california.smartrx-dev.lh.primetherapeutics.com': {
    login: `${protocol}://${host}/provider/login`,
    logout: `${protocol}://${host}/provider/login`,
    home: `${protocol}://${host}/provider/dashboard`,
    contact: `${protocol}://${host}/provider/contact`
  }, 
  'california.smartrx-test.lh.primetherapeutics.com': {
    login: `${protocol}://${host}/provider/login`,
    logout: `${protocol}://${host}/provider/login`,
    home: `${protocol}://${host}/provider/dashboard`,
    contact: `${protocol}://${host}/provider/contact`
  }, 
  'california.smartrx-prod.lh.primetherapeutics.com': {
    login: `${protocol}://${host}/provider/login`,
    logout: `${protocol}://${host}/provider/login`,
    home: `${protocol}://${host}/provider/dashboard`,
    contact: `${protocol}://${host}/provider/contact`
  },
  'californiaqa.magellanrx.com': {
    login: `${protocol}://${host}/provider/login`,
    logout: `${protocol}://${host}/provider/login`,
    home: `${protocol}://${host}/provider/dashboard`,
    contact: `${protocol}://${host}/provider/contact`
  },
  'ca-dev.primetherapeutics.com': {
    login: `${protocol}://${host}/provider/login`,
    logout: `${protocol}://${host}/provider/login`,
    home: `${protocol}://${host}/provider/dashboard`,
    contact: `${protocol}://${host}/provider/contact`
  }, 
  'ca-test.primetherapeutics.com': {
    login: `${protocol}://${host}/provider/login`,
    logout: `${protocol}://${host}/provider/login`,
    home: `${protocol}://${host}/provider/dashboard`,
    contact: `${protocol}://${host}/provider/contact`
  }, 
  'ca.primetherapeutics.com': {
    login: `${protocol}://${host}/provider/login`,
    logout: `${protocol}://${host}/provider/login`,
    home: `${protocol}://${host}/provider/dashboard`,
    contact: `${protocol}://${host}/provider/contact`
  },
  'medi-calrx.dhcs.ca.gov': {
    login: `${protocol}://${host}/provider/login`,
    logout: `${protocol}://${host}/provider/login`,
    home: `${protocol}://${host}/provider/dashboard`,
    contact: `${protocol}://${host}/provider/contact`
  }
}

const oktaAuth = new OktaAuth({
  url: OKTA_INFO[hostname].url,
  clientId: OKTA_INFO[hostname].clientId,
  issuer: `${OKTA_INFO[hostname].url}/oauth2/default`,
  redirectUri: redirectUrl,
  tokenManager: {
    storage: "sessionStorage",
  },
});

function clearStorage() {
  window.localStorage.clear();
  window.sessionStorage.clear();
  window.location = REDIRECT_URL[hostname].logout;
}

const checkAuthentication = async () => {
  try {
    const session = oktaAuth && oktaAuth.session && await oktaAuth.session.refresh()

    if (session && session.status !== 'INACTIVE') {
      const tokens = await oktaAuth.token.getWithoutPrompt({
        scopes: ['openid', 'email', 'profile', 'groups', 'offline_access'],
        responseType: ['id_token', 'token'],
      });

      let idTokenClaims = null;

      tokens.forEach(token => {
        if (token.idToken) {
          oktaAuth.tokenManager.add('idToken', token);
          idTokenClaims = token.claims
        }
        if (token.accessToken) {
          oktaAuth.tokenManager.add('accessToken', token);
        }
      })

      return idTokenClaims;
    }

    if (window.location.hostname !== 'localhost') {
      logout();
    }
    throw new Error('Invalid Login Session');

  } catch (err) {
    console.error("Authentication error")

    if (window.location.hostname !== 'localhost') {
      logout();
    }
    return 'ERROR';
  }
};

const getOktaAccessToken = () => {
  const token = getOktaStorageToken()
  if (token) {
    return token.accessToken.accessToken;
  }
  return null;
};

const getOktaIdToken = () => {
  const token = getOktaStorageToken()
  if (token) {
    return token.idToken.idToken;
  }
  return null;
};

const getOktaStorageToken = () => JSON.parse(window.localStorage.getItem('okta-token-storage'));

const logout = async () => {
  if (typeof oktaAuth.signOut === 'function') {
    await oktaAuth.signOut();
    clearStorage();
    trackEvent('logout in Member', 'Member clicked  Member');
  }
}

const getLoginUrl = () => {
  return REDIRECT_URL[hostname].login
}

const getHomeUrl = () => {
  return REDIRECT_URL[hostname].home
}

const getContactUrl = () => {
  return REDIRECT_URL[hostname].contact
}

export { oktaAuth, OKTA_INFO, logout, checkAuthentication, getOktaAccessToken, getOktaIdToken, getOktaStorageToken, getLoginUrl, getHomeUrl, getContactUrl };
